import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import Layout from './components/Layout';
import Home from './pages/Home';
import Contact from './pages/Contact';
import Features from './pages/Features';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Signup from './pages/Signup';
import Login from './pages/Login';
import EmailLogin from './pages/EmailLogin';
import ForgotPassword from './pages/ForgotPassword';
import PaymentSuccess from './pages/PaymentSuccess';
import Checkout from './pages/Checkout';
import CheckoutV2 from './pages/CheckoutV2';
import Guide from './pages/Guide';
import Windows from './pages/tutorials/Windows';
import Mac from './pages/tutorials/Mac';
import Ubuntu from './pages/tutorials/Ubuntu';
import Android from './pages/tutorials/Android';
import IOS from './pages/tutorials/IOS';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="contact" element={<Contact />} />
        <Route path="feature" element={<Features />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="tos" element={<TermsOfService />} />
        <Route path="signup" element={<Signup />} />
        <Route path="login" element={<Login />} />
        <Route path="email-login" element={<EmailLogin />} />
        <Route path="checkout" element={<Checkout />} />
        <Route path="checkout/v2" element={<CheckoutV2 />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="success" element={<PaymentSuccess />} />
        <Route path="guide" element={<Guide />} />
        <Route path="tutorials/vpn_connect_windows" element={<Windows />} />
        <Route path="tutorials/vpn_connect_mac" element={<Mac />} />
        <Route path="tutorials/vpn_connect_ubuntu" element={<Ubuntu />} />
        <Route path="tutorials/vpn_connect_android" element={<Android />} />
        <Route path="tutorials/vpn_connect_ios_app" element={<IOS />} />
      </Route>
    </Routes>
  );
}

export default App;
